const rawBase = String(process.env.BASE_URL || "/");

const normalizedBase = rawBase === "/" ? "" : rawBase.replace(/\/$/, "");

export function withBase(path = "") {
  if (!path) {
    return normalizedBase || "/";
  }

  if (/^(https?:)?\/\//.test(path) || path.startsWith("data:")) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}

export function withOrigin(path = "") {
  return `${window.location.origin}${withBase(path)}`;
}
